export default {
  baseUrl: 'http://ldev.gunet.gr/nlg-api',
  newsletterUrl: '/newsletter/subscribe'
}
